import React from "react";

const QuestionSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="11.772"
      height="11.772"
      viewBox="0 0 11.772 11.772"
    >
      <path
        fill="#e2b319"
        d="M13.886 8a5.886 5.886 0 105.886 5.886A5.887 5.887 0 0013.886 8zm0 10.633a4.747 4.747 0 114.747-4.747 4.744 4.744 0 01-4.747 4.747zm2.545-6.057c0 1.591-1.719 1.616-1.719 2.2v.15a.285.285 0 01-.285.285h-1.083a.285.285 0 01-.285-.285v-.206c0-.848.643-1.187 1.129-1.46.417-.234.672-.393.672-.7 0-.409-.522-.681-.944-.681-.55 0-.8.261-1.162.711a.285.285 0 01-.4.05l-.66-.5a.285.285 0 01-.063-.388 2.668 2.668 0 012.387-1.286 2.357 2.357 0 012.413 2.11zm-1.548 3.968a1 1 0 11-1-1 1 1 0 011 1z"
        transform="translate(-8 -8)"
      ></path>
    </svg>
  );
};

export default QuestionSVG;
